import { React, useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import axios from "axios";
import Swal from "sweetalert2";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ItemRegModal from "../../../../modal/PC/gijun/ItemRegModal";
import ItemUpdateModal from "../../../../modal/PC/gijun/ItemUpdateModal";
import styled from "styled-components";
import Select from 'react-select';
import { AppContext } from '../../../../AppStore';
import Moment from 'moment';
import { useNavigate, useLocation } from "react-router-dom";

const Item = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [originRows, setOriginRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [keyword, setKeyword] = useState({
        type:0,
        division:0,
        search:''
    });
    const [mainPartnerOption, setMainPartnerOption] = useState([]);
    const [itemInOutOption, setItemInOutOption] = useState([]);
    const [typeOption, setTypeOption] = useState([]);
    const [typeModalOption, setTypeModalOption] = useState([]);
    const [divisionOption, setDivisionOption] = useState([]);
    const [divisionModalOption, setDivisionModalOption] = useState([]);
    const [unitModalOption, setUnitModalOption] = useState([]);
    const [stockCurrencyModalOption, setStockCurrencyModalOption] = useState([]);
    const [unitCurrencyModalOption, setUnitCurrencyModalOption] = useState([]);
    const [expirationModalOption, setExpirationModalOption] = useState([]);
    const [isRegModalOpen, setRegModalOpen] = useState(false);
    const [isUpdateModalOpen, setUpdateModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalVersion, setModalVersion] = useState([]);
    const [selectItemID, setSelectItemID] = useState('');
    
    // Grid정의
    const handleSetting = () => {
        setColumns([
            (MenuUpdateExistYN === "Y"?
            {
                field: 'updated',
                headerName: '수정',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<EditIcon color="primary" />} onClick={() => {UpdateClick(params)}} label="Edit" />
                ],
                headerAlign: 'center', 
                align:'center'
            } : {}),
            (MenuDeleteExistYN === "Y"?
            {
                field: 'deleted',
                headerName: '삭제',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<DeleteIcon color={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y' ? "error" : "grey"} />} onClick={() => {DeleteClick(params)}} label="Delete" disabled={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y'? false : true } />
                ],
                headerAlign: 'center', 
                align:'center'
            } : {}),
            { field: 'id', headerName: 'item_id', width: 0, headerAlign: 'center' },
            { field: 'item_version_seq', headerName: 'item_version_seq', width: 0, headerAlign: 'center' },
            { field: 'item_max_version_seq', headerName: 'item_max_version_seq', width: 0, headerAlign: 'center' },
            { field: 'item_name', headerName: '품목명', width: 250, headerAlign: 'center' },
            { field: 'item_type_name', headerName: '유형', width: 100, headerAlign: 'center', align:'center' },
            { field: 'item_division_name', headerName: '분류', width: 100, headerAlign: 'center', align:'center' },
            { field: 'item_spec', headerName: '규격', width: 250, headerAlign: 'center', align:'left' },
            { field: 'item_width', headerName: '가로', width: 95, headerAlign: 'center', align:'right' },
            { field: 'item_depth', headerName: '세로', width: 95, headerAlign: 'center', align:'right' },
            { field: 'item_height', headerName: '높이', width: 95, headerAlign: 'center', align:'right' },
            { field: 'item_unit_name', headerName: '단위', width: 90, headerAlign: 'center', align:'center' },
            { field: 'item_stock_currency_price', headerName: '재고평가금액', width: 150, headerAlign: 'center', align:'right' },
            { 
                field: 'item_total_safe_stock_count', 
                headerName: '안전재고', 
                width: 120, 
                headerAlign: 'center', 
                align:'right',
                valueFormatter: (value) => {
                    const val = (value && value.value !== undefined) ? value.value : value;
                    return Number(val || 0).toLocaleString(); 
                }
            }
        ]);
    }

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false,
        item_version_seq: false,
        item_max_version_seq: false,
        item_name: true,
        item_spec: true,
        item_type_name: true,
        item_division_name: true,
        item_width: true,
        item_depth: true,
        item_height: true,
        item_unit_name: true,
        item_stock_currency_price: true,
        item_total_safe_stock_count: true,
        item_monthly_usage: false,
        deleted: true,
        updated: true
    });

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleView();
        }
    }, [keyword.type, keyword.division]);

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting();
            handleInitSelect();
            handleInit();
            handleView();
        }
    }, [MenuID]);

    // Grid 데이터 조회
    const handleView = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);
        
        axios.get('/api/p/Item/List',
            {
            params : {
              type: keyword.type,
              division: keyword.division,
              search : keyword.search
            }
          },
          { withCredentials: true }
        )
        .then((response) => {
            const PermissionMap = {};
            const makeKey = (id, ver) => `${id}#${ver}`;
            response.data.forEach((row) => {
                const key = makeKey(row.item_id, row.item_version_seq);
                const hit = Number(row.reg_user_id) === Number(localStorage.getItem('user_id')); // 필요하면 다른 필드도 OR 추가 가능
                PermissionMap[key] = (PermissionMap[key] ?? false) || hit;
            });

            let array = response.data.map((item) => {
                const key = makeKey(item.item_id, item.item_version_seq);
                return {
                    id: item.item_id,
                    item_version_seq: item.item_version_seq,
                    item_max_version_seq: item.item_max_version_seq,
                    item_name: item.item_name,
                    item_spec: item.item_spec,
                    item_type_name: item.item_type_name,
                    item_division_name: item.item_division_name,
                    item_width: item.item_width,
                    item_depth: item.item_depth,
                    item_height: item.item_height,
                    item_unit_name: item.item_unit_name,
                    item_stock_currency_price: item.item_stock_currency_price,
                    item_total_safe_stock_count: item.item_total_safe_stock_count,
                    item_monthly_usage: item.item_monthly_usage,
                    update_flag: PermissionMap[key] ? 'Y' : 'N'
                };
            });

            array = array.filter((element) => element.item_id === element.item_id && element.item_version_seq === element.item_max_version_seq);
            setOriginRows(response.data);
            setRows([ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse));
            
            var version_array = [];
            for(var i=1; i<=Number((array.filter((element) => String(element.id) === String(selectItemID)))[0].item_max_version_seq); i++){
                version_array.push({value:i, label:i});
            }
            setModalVersion(version_array);
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false);
        });

    }

    const handleInitSelect = () => {
        
        // 품목유통, 품목분류, 단위, 통화단위, 유통기한유형
        axios.get('/api/Common/CodeDetailList')
        .then((response) => { 

            var type_array = [];
            var type_array_modal = [];
            var division_array = [];
            var division_array_modal = [];
            var unit_array_modal = [];
            var stock_currency_array_modal = [];
            var unit_currency_array_modal = [];
            var expiration_array_modal = [];
            for(let i=0; i<(response.data).length; i++){

                if((response.data)[i].code_id === '0014'){
                    type_array.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                    type_array_modal.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                }else if((response.data)[i].code_id === '0015'){
                    division_array.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                    division_array_modal.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                }else if((response.data)[i].code_id === '0016'){
                    unit_array_modal.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                }else if((response.data)[i].code_id === '0017'){
                    stock_currency_array_modal.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                    unit_currency_array_modal.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                }else if((response.data)[i].code_id === '0019'){
                    expiration_array_modal.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                }

            }

            type_array.unshift({ value: 0, label : '유형'});
            division_array.unshift({ value: 0, label : '분류'});
            stock_currency_array_modal.unshift({ value: 0, label : '통화'});
            unit_currency_array_modal.unshift({ value: 0, label : '통화'});
            expiration_array_modal.unshift({ value: 0, label : '유통기한유형'});

            setMainPartnerOption([{value:'Y', label:'Y'},{value:'N', label:'N'}]);
            setItemInOutOption([{value:'I', label:'매입'},{value:'O', label:'매출'}]);
            setTypeModalOption(type_array_modal);
            setTypeOption(type_array);
            setDivisionModalOption(division_array_modal);
            setDivisionOption(division_array);
            setUnitModalOption(unit_array_modal);
            setStockCurrencyModalOption(stock_currency_array_modal);
            setUnitCurrencyModalOption(unit_currency_array_modal);
            setExpirationModalOption(expiration_array_modal);
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const handleInit = () => {
        setKeyword({
            type:0,
            division:0,
            search:''
        })
        
        // Hide컬럼 숨기기.
        setColumnVisibilityModel({
            id: false,
            item_version_seq: false,
            item_max_version_seq: false,
            item_name: true,
            item_spec: true,
            item_type_name: true,
            item_division_name: true,
            item_width: true,
            item_depth: true,
            item_height: true,
            item_unit_name: true,
            item_stock_currency_price: true,
            item_total_safe_stock_count: true,
            deleted: true,
            updated: true,
            update_flag: false
        });
    };

    const handleReg = () => {
        setRegModalOpen(true);
        setModalTitle('품목 등록');
    };
    
    const UpdateClick = (object) => {
        var version_array = [];
        for(var i=1; i<=Number(object.row.item_max_version_seq); i++){
            version_array.push({value:i, label:i});
        }
        setSelectItemID(object.row.id);
        setModalVersion(version_array);
        setUpdateModalOpen(true);
        setModalTitle('품목 수정');
    };

    const DeleteClick = (object) => {
        Swal.fire({
            title: '품목 '+object.row.item_name+' 삭제',
            html : '품목 '+object.row.item_name+'을(를) <span style="color:red; font-weight:bold;">삭제</span> 하시겠습니까?<br/>삭제하시면 복구 할 수 없습니다.',
            showCancelButton : true,
            confirmButtonColor : "#d33",
            confirmButtonText : "삭제",
            cancelButtonText : "닫기"
        }).then((result) => {
            if (result.isConfirmed) {
                if (appStore.loading) return;
                appStore.setLoading(true);

                axios.post('/api/p/Item/Delete', new URLSearchParams({
                    delete_item_id: object.row.id
                }),
                { withCredentials: true })
                .then(function (response) {
                    if(response.status === 200){
                        Swal.fire({
                            title: '품목 '+object.row.item_name+' 삭제 완료',
                            text: '정상적으로 품목 '+object.row.item_name+'가 삭제 되었습니다.',
                            confirmButtonText: '확인',
                            timer: 5000,
                            timerProgressBar: true
                        }).then((result) => {
                            setRows((rows) => rows.filter((data) => data.id !== object.row.id));
                        });
                    }else{
                        appStore.capture();
                    }
                })
                .catch(function (error) {
                    appStore.capture();
                })
                .finally(() => {
                    appStore.setLoading(false);
                });
            }
        });
    };

    const onSelectChange = (type, value) => {
        const nextKeyword = {
            ...keyword,
            [type] : value
        };
        setKeyword(nextKeyword);
    };

    const onChange = (e)=>{
        const {name, value} = e.target;
        const nextKeyword = {
            ...keyword,
            [name]: value, 
        };
        setKeyword(nextKeyword);
    };

    const onSubmitSearch = (e) => {
        //입력 검색어는 Enter로 조회.
        if (e.key === "Enter") {
          handleView();
        }
    };
    
    const handleRegSuccessSave = (regID) => {
        setModalTitle('품목 수정');
        setRegModalOpen(false);
        handleView();

        Swal.fire({
            title: '품목 등록 완료',
            text: '정상적으로 품목이 등록 되었습니다.',
            confirmButtonText: '확인',
            timer: 5000,
            timerProgressBar: true
        }).then((result) => {
            // 수정 화면 불러오기
            setUpdateModalOpen(true);
            setSelectItemID(Number(regID));
        });
    };
    
    const handleExcel = () => {
        var filename = '품목관리'
        axios.get('/api/p/Item/Excel',
        {   
            params : { type: keyword.type, division: keyword.division, search : keyword.search, file_name: filename },
            responseType:'blob'
        },
        { withCredentials: true })
        .then(function (response) {
            
            if(response.status === 200){
                filename = filename + ' ' + appStore.YYYY_MM_DD_HH_MI_SS();
                const link = document.createElement('a');
                link.href = URL.createObjectURL(response.data);
                link.setAttribute('download', filename+'.xlsx');
                document.body.appendChild(link);
                link.click();
            }
        })
        .catch(function (error) {
            appStore.capture();
        })
    };

    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox">
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                    <div className="menu-button">
                    { MenuUpdateYN === "Y"?
                    <Button 
                        onClick={ handleReg }
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        등록
                    </Button> : <></> }
                    {isRegModalOpen  && MenuUpdateYN === 'Y'&& (
                        <ItemRegModal
                        onClose={() => {
                            setRegModalOpen(false);
                        }}
                        title={modalTitle}
                        handleRegSuccessSave={handleRegSuccessSave}
                        mainPartnerOption={mainPartnerOption}
                        itemInOutOption={itemInOutOption}
                        typeModalOption={typeModalOption}
                        divisionModalOption={divisionModalOption}
                        unitModalOption={unitModalOption}
                        stockCurrencyModalOption={stockCurrencyModalOption}
                        unitCurrencyModalOption={unitCurrencyModalOption}
                        expirationModalOption={expirationModalOption}
                        MenuUpdateYN={MenuUpdateYN}
                        />
                    )}
                    <Button 
                        onClick={ handleExcel }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#00AC47", 
                            backgroundColor: "#00AC47",
                            ":hover": { boxShadow: "2px 2px 2px #00AC47" , backgroundColor: "#00AC47", borderColor: "#00AC47"}
                        }} 
                        variant="outlined">
                        엑셀
                    </Button>
                    <Button 
                        onClick={ handleInit }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "black", 
                            backgroundColor: "black",
                            ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                        }} 
                        variant="outlined">
                        초기화
                    </Button>
                    <Button 
                        onClick={ handleView }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#3D63AE", 
                            backgroundColor: "#3D63AE",
                            ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                        }} 
                        variant="outlined">
                        조회
                    </Button>
                    </div>
                </div>
                <div className="menu-keyword">
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title">
                            유형
                        </div>
                        <div className="menu-keyword-sub-keyword">
                            <Select className="menu-keyword-sub-keyword-select" placeholder="유형" onChange={(e) => onSelectChange('type',e.value)} value={typeOption.filter(function (option) { return option.value === keyword.type;  })} options={typeOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                    </div>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title">
                            분류
                        </div>
                        <div className="menu-keyword-sub-keyword">
                            <Select className="menu-keyword-sub-keyword-select" placeholder="분류" onChange={(e) => onSelectChange('division',e.value)} value={divisionOption.filter(function (option) { return option.value === keyword.division;  })} options={divisionOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                    </div>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '300px' } }>
                            <input type="text" placeholder="검색" value={keyword.search} name="search" onChange={(e) => onChange(e) } onKeyPress={onSubmitSearch} autoComplete="off" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid">
                <div className="grid_sub" style={ { width: '100%', fontSize: '17px' } }>
                    <DataGrid
                        className="grid_main"
                        rows={rows}
                        columns={columns}
                        slots={{
                            noRowsOverlay: GridNoRow,
                        }}
                        columnVisibilityModel={columnVisibilityModel}
                        AlternatingRowBackground="LavenderBlush"
                        rowsPerPageOptions={[20, 50, 100]}
                    />
                    {isUpdateModalOpen && (
                        <ItemUpdateModal
                        onClose={() => {
                            setUpdateModalOpen(false);
                        }}
                        title={modalTitle}
                        version={modalVersion}
                        id={selectItemID}
                        originRows={originRows.filter(row => String(row.item_id) === String(selectItemID))}
                        handleView={handleView}
                        mainPartnerOption={mainPartnerOption}
                        itemInOutOption={itemInOutOption}
                        typeModalOption={typeModalOption}
                        divisionModalOption={divisionModalOption}
                        unitModalOption={unitModalOption}
                        stockCurrencyModalOption={stockCurrencyModalOption}
                        unitCurrencyModalOption={unitCurrencyModalOption}
                        expirationModalOption={expirationModalOption}
                        MenuUpdateYN={MenuUpdateYN}
                        MenuDeleteYN={MenuDeleteYN}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;

export default Item;
